// TSS vite/03 §"Query keys convention".
//
// `tickets` es una entidad propia y no una vista de otra cosa — al revés que
// los hallazgos, que son tareas y por eso comparten su clave. Un ticket tiene
// su tabla, su ciclo y sus rutas; nada lo invalida desde otra pantalla.

export const ticketKeys = {
    all:    ['tickets'],
    list:   (params) => ['tickets', 'list', params],
    detail: (id) => ['tickets', 'detail', id],
};

// EL RECUENTO POR ESTADO NO TIENE CLAVE PROPIA, y es a propósito: son tres
// consultas al MISMO listado con `limit: 1` y un `state` distinto, así que usan
// `list(params)` como cualquier otra. Una clave `tally` habría sido un segundo
// nombre para las mismas filas — y la invalidación de una mutación, que borra
// `['tickets']` entero, sigue alcanzándolas sin que nadie se acuerde de sumarla.
